import { styled } from '@zenbusiness/zui/styles';

export const EmptyStatementWrapperStyled = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main,
  borderRadius: 16,
  padding: 16
}));

export const MainContentWrapStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'center',
  maxWidth: 736,
  margin: '0 auto',
  height: 292,
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    height: 304
  }
}));

export const DescriptionSessionStyled = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  maxWidth: 400
}));

export const TitleStyled = styled('span')(({ theme }) => ({
  ...theme.typography.xl,
  color: theme.palette.text.primary,
  [theme.breakpoints.up('md')]: {
    fontSize: '1.375rem',
    lineHeight: '1.75rem'
  }
}));

export const DescriptionStyled = styled('span')(({ theme }) => ({
  ...theme.typography.lg,
  color: theme.palette.text.tertiary,
  marginTop: 4,
  lineHeight: '1.5rem',
  [theme.breakpoints.up('md')]: {
    lineHeight: '1.5rem'
  }
}));
